import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { z } from "zod";

import { ErrorBoundary } from "@/components/error-boundary";
import { RequestsPage } from "@/features/requests";

const requestsSearchSchema = z.object({
  filter: z
    .enum(["all", "graphic", "video", "webui"])
    .optional()
    .default("all"),
  scroll: z.enum(["in-queue"]).optional(),
  search: z.union([z.string(), z.number().transform(String)]).optional(),
  tab: z
    .enum([
      "all",
      "active",
      "queued",
      "completed",
      "drafts",
      "open",
      "paused",
      "archived",
      "due-today",
      "overdue",
      "ready-for-review",
      "assigned-to-me",
      "all-requests",
      "team-requests",
      "unassigned-requests",
      "assigned-to-any",
    ])
    .optional(),
});

export const Route = createFileRoute("/_auth/_app-shell/requests/")({
  component: () => (
    <Suspense fallback={<RequestsPageWrapper />}>
      <RequestsPageWrapper>
        <ErrorBoundary>
          <RequestsPage />
        </ErrorBoundary>
      </RequestsPageWrapper>
    </Suspense>
  ),
  validateSearch: requestsSearchSchema,
});

function RequestsPageWrapper({ children }: { children?: React.ReactNode }) {
  return children;
}
